// Order status configuration for consistent display across all roles

export const orderStatusConfig = {
  pending: { label: 'Pending', color: 'text-yellow-600', bg: 'bg-yellow-50', badge: '🟡' },
  claimed: { label: 'Claimed (Waiting for Pickup)', color: 'text-blue-600', bg: 'bg-blue-50', badge: '🔵' },
  in_transit: { label: 'In Transit', color: 'text-purple-600', bg: 'bg-purple-50', badge: '🚚' },
  delivered: { label: 'Delivered', color: 'text-green-600', bg: 'bg-green-50', badge: '✅' },
  cancelled: { label: 'Cancelled', color: 'text-red-600', bg: 'bg-red-50', badge: '❌' },
  refunded: { label: 'Refunded', color: 'text-gray-600', bg: 'bg-gray-50', badge: '💰' },
  damaged: { label: 'Damaged', color: 'text-orange-600', bg: 'bg-orange-50', badge: '⚠️' }
};

export function getStatusInfo(status) {
  return orderStatusConfig[status] || { label: status, color: 'text-gray-600', bg: 'bg-gray-50', badge: '📦' };
}

export function getNextStatuses(currentStatus, role) {
  const transitions = {
    pickup: {
      claimed: ['in_transit'],
      in_transit: ['delivered']
    },
    hub: {
      pending: ['cancelled']
    },
    producer: {
      pending: ['cancelled']
    },
    admin: {
      pending: ['cancelled', 'refunded', 'damaged'],
      claimed: ['cancelled', 'refunded', 'damaged'],
      in_transit: ['cancelled', 'refunded', 'damaged'],
      delivered: ['refunded']
    }
  };
  
  return transitions[role]?.[currentStatus] || [];
}
